// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { saveLmsFile } from "../utils/lmsFiles";

/*
 * Pieces every Training screen shares: loading a copilot-api envelope, the loading/error line, and
 * a download button. Kept apart from Learning.tsx so the launch screens (View All, transcript,
 * training admin, sign-up) can use them without importing the page.
 */

const envelope = (resp) => resp?.data;
export const ok = (resp) => envelope(resp)?.status === 1;
export const payload = (resp) => envelope(resp)?.data;
export const message = (resp, fallback) => envelope(resp)?.message || fallback;
/** The AVS OS refusal code copilot-api passes through (e.g. self_enroll_off, no_learner). */
export const refusalCode = (resp) => (ok(resp) ? null : envelope(resp)?.data?.code || null);

export function useLoad(loader, deps) {
  const [state, setState] = useState({ loading: true, error: null, code: null, data: null });
  const reload = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null, code: null }));
    const resp = await loader();
    if (ok(resp)) setState({ loading: false, error: null, code: null, data: payload(resp) });
    else
      setState({
        loading: false,
        error: message(resp, "Training couldn't be loaded, please try again."),
        code: refusalCode(resp),
        data: null,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(() => {
    reload();
  }, [reload]);
  return { ...state, reload };
}

export function Status({ loading, error, onRetry }) {
  if (loading)
    return (
      <p className="text-body-secondary small" role="status" data-testid="learning-loading">
        Loading&hellip;
      </p>
    );
  if (error)
    return (
      <div className="alert alert-secondary d-flex justify-content-between align-items-center" role="alert" data-testid="learning-error">
        <span>{error}</span>
        {onRetry && (
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onRetry} data-testid="learning-retry">
            Try again
          </button>
        )}
      </div>
    );
  return null;
}

/**
 * A download button: the file streams through copilot-api, and a refusal shows next to the button
 * instead of a toast, so the person can see which download failed.
 */
export function DownloadButton({ kind, id, label, fileLabel, className = "btn btn-outline-secondary btn-sm", icon = "fa-solid fa-download", testid }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const run = async () => {
    setBusy(true);
    setError(null);
    const err = await saveLmsFile(kind, id, fileLabel);
    setBusy(false);
    setError(err);
  };
  return (
    <span className="d-inline-flex flex-column align-items-start">
      <button type="button" className={className} onClick={run} disabled={busy} aria-busy={busy} data-testid={testid}>
        <i className={`${icon} me-1`} aria-hidden="true" />
        {busy ? "Preparing…" : label}
      </button>
      {error && (
        <span className="small text-danger mt-1" role="alert" data-testid={testid ? `${testid}-error` : undefined}>
          {error}
        </span>
      )}
    </span>
  );
}
